import styled from 'styled-components';

export const GallerySection = styled.div`
  color: #fff;
  padding: 60px 0;
  background: #f9f9f9;
`;

export const GalleryRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px; /* spacing between images */
`;

export const ImageWrapper = styled.div`
  flex: 0 1 calc(33.333% - 20px); /* 3 images per row with gap */
  max-width: calc(33.333% - 20px);
  box-sizing: border-box;
`;

export const GalleryImage = styled.img`
  width: 100%;
  height: auto;
  border-radius: 12px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);
`;
